// removed by extract-text-webpack-plugin
module.exports = {"button-container":"purify_Footer__button-container___2Scfk","Footer":"purify_Footer__Footer___2aSoi","center":"purify_Footer__center___3L0WE","left":"purify_Footer__left___zHyW4","right":"purify_Footer__right___3nbew"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Footer/Footer.scss
// module id = 180
// module chunks = 0